import { Component, OnInit } from '@angular/core';
import { SystemsPartnerGuardService } from 'src/app/core/auth/systems-partner-guard.service';

import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { FooterComponent as BaseFooterComponent } from '@systems/base';

@Component({
    standalone: true,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [BaseFooterComponent, RouterLink, TranslatePipe],
})
export class FooterComponent implements OnInit {

  get isSystems(): boolean {
    return this.systemsPartnerGuard.isSystems;
  }

  constructor(
    private systemsPartnerGuard: SystemsPartnerGuardService
  ) { }

  ngOnInit(): void {
  }

}
